const SET_SUBSIDIARY = 'SET_SUBSIDIARY';
const SET_ERROR_IMPORT = 'SET_ERROR_IMPORT';

export { SET_SUBSIDIARY, SET_ERROR_IMPORT };
